import React from 'react'
import { instanceOf, func, string } from 'prop-types';

const MapViewSettings = ({ view, data, handleViewChange, dropdownListTitle }) => {
  const _handleViewChange = evt => {
    handleViewChange(evt.target.value)
  }

  return (
    <div className="map--settings-view">
      <div className="map--settings-view__title">{dropdownListTitle}</div>
      <select
        onChange={e => _handleViewChange(e)}
        disabled={data.length === 1}
        className={`map--settings-view__select ${data.length > 1 ?
          "" : "map--settings-view__select--disabled"}`
        }
        value={view}
      >
        {data.map(view => (
          <option>{view}</option>
        ))}
      </select>
    </div>
  )
}

MapViewSettings.propTypes = {
  data: instanceOf(Array),
  handleViewChange: func,
  view: string,
}

export default MapViewSettings;